// Errors are flattened to a plain object before crossing the worker boundary.
// Structured clone can copy Error instances in modern browsers, but serialising
// explicitly avoids DataCloneError on errors carrying non-cloneable fields and
// keeps exactly the data the main-thread Sentry needs (name, message, stack).

type SerializedError = {
	readonly name: string;
	readonly message: string;
	readonly stack: string | undefined;
};

function serializeError(error: unknown): SerializedError {
	if (error instanceof Error) {
		return {
			name: error.name,
			message: error.message,
			stack: error.stack,
		};
	}
	return {
		name: "NonError",
		message: typeof error === "string" ? error : JSON.stringify(error),
		stack: undefined,
	};
}

function deserializeError({ name, message, stack }: SerializedError): Error {
	const error = new Error(message);
	error.name = name;
	if (stack !== undefined) {
		error.stack = stack;
	}
	return error;
}

export type { SerializedError };
export { serializeError, deserializeError };
